import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-goed',
  templateUrl: './button-goed.component.html',
  styleUrls: ['./button-goed.component.less']
})
export class ButtonGoedComponent implements OnInit {
  @Input() caption = '';
  @Input() disabled = false;
  constructor() { }

  ngOnInit(): void {
  }

}
